import {
  limitedReleaseByVersionConstants,
  createLimitedReleaseByVersionConstants,
  editLimitedReleaseByVersionConstants,
  addTargetLimitedReleaseByVersionConstants,
  removeTargetLimitedReleaseByVersionConstants,
  activateLimitedReleaseByVersionConstants,
  deactivateLimitedReleaseByVersionConstants,
  deleteLimitedReleaseByVersionConstants,
} from "../_redux-constants";
import { limitedReleasesVersionService } from "../../_services";
import { errorExtractor } from "../../_helpers";

function getLimitedReleaseByVersion(queryParams) {
  function getLimitedReleaseByVersionLoad() {
    return {
      type: limitedReleaseByVersionConstants.LIMITED_RELEASE_BY_VERSION_LOADING,
    };
  }
  function getLimitedReleaseByVersionSuccess(data) {
    return {
      type: limitedReleaseByVersionConstants.LIMITED_RELEASE_BY_VERSION_SUCCESS,
      data,
    };
  }
  function getLimitedReleaseByVersionFailure(error) {
    return {
      type: limitedReleaseByVersionConstants.LIMITED_RELEASE_BY_VERSION_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getLimitedReleaseByVersionLoad());
    return limitedReleasesVersionService
      .getLimitedReleaseByVersion(queryParams)
      .then(
        (data) => {
          dispatch(getLimitedReleaseByVersionSuccess(data));
        },
        (error) => {
          dispatch(getLimitedReleaseByVersionFailure(error?.toString()));
        }
      );
  };
}

function createLimitedReleaseByVersion(requestBody, queryParams) {
  function createLimitedReleaseByVersionLoad() {
    return {
      type: createLimitedReleaseByVersionConstants.CREATE_LIMITED_RELEASE_BY_VERSION_LOADING,
    };
  }
  function createLimitedReleaseByVersionSuccess(data) {
    return {
      type: createLimitedReleaseByVersionConstants.CREATE_LIMITED_RELEASE_BY_VERSION_SUCCESS,
      data,
    };
  }
  function createLimitedReleaseByVersionFailure(error) {
    return {
      type: createLimitedReleaseByVersionConstants.CREATE_LIMITED_RELEASE_BY_VERSION_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(createLimitedReleaseByVersionLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesVersionService
        .createLimitedReleaseByVersion(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(createLimitedReleaseByVersionSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(createLimitedReleaseByVersionFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function editLimitedReleaseByVersion(requestBody, queryParams) {
  function editLimitedReleaseByVersionLoad() {
    return {
      type: editLimitedReleaseByVersionConstants.EDIT_LIMITED_RELEASE_BY_VERSION_LOADING,
    };
  }
  function editLimitedReleaseByVersionSuccess(data) {
    return {
      type: editLimitedReleaseByVersionConstants.EDIT_LIMITED_RELEASE_BY_VERSION_SUCCESS,
      data,
    };
  }
  function editLimitedReleaseByVersionFailure(error) {
    return {
      type: editLimitedReleaseByVersionConstants.EDIT_LIMITED_RELEASE_BY_VERSION_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(editLimitedReleaseByVersionLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesVersionService
        .editLimitedReleaseByVersion(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(editLimitedReleaseByVersionSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(editLimitedReleaseByVersionFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function addTargetLimitedReleaseByVersion(requestBody, queryParams) {
  function addTargetLimitedReleaseByVersionLoad() {
    return {
      type: addTargetLimitedReleaseByVersionConstants.ADD_TARGET_LIMITED_RELEASE_BY_VERSION_LOADING,
    };
  }
  function addTargetLimitedReleaseByVersionSuccess(data) {
    return {
      type: addTargetLimitedReleaseByVersionConstants.ADD_TARGET_LIMITED_RELEASE_BY_VERSION_SUCCESS,
      data,
    };
  }
  function addTargetLimitedReleaseByVersionFailure(error) {
    return {
      type: addTargetLimitedReleaseByVersionConstants.ADD_TARGET_LIMITED_RELEASE_BY_VERSION_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(addTargetLimitedReleaseByVersionLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesVersionService
        .addTargetLimitedReleaseByVersion(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(addTargetLimitedReleaseByVersionSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(
              addTargetLimitedReleaseByVersionFailure(error?.toString())
            );
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function removeTargetLimitedReleaseByVersion(queryParams) {
  function removeTargetLimitedReleaseByVersionLoad() {
    return {
      type: removeTargetLimitedReleaseByVersionConstants.REMOVE_TARGET_LIMITED_RELEASE_BY_VERSION_LOADING,
    };
  }
  function removeTargetLimitedReleaseByVersionSuccess(data) {
    return {
      type: removeTargetLimitedReleaseByVersionConstants.REMOVE_TARGET_LIMITED_RELEASE_BY_VERSION_SUCCESS,
      data,
    };
  }
  function removeTargetLimitedReleaseByVersionFailure(error) {
    return {
      type: removeTargetLimitedReleaseByVersionConstants.REMOVE_TARGET_LIMITED_RELEASE_BY_VERSION_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(removeTargetLimitedReleaseByVersionLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesVersionService
        .removeTargetLimitedReleaseByVersion(queryParams)
        .then(
          (data) => {
            dispatch(removeTargetLimitedReleaseByVersionSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(
              removeTargetLimitedReleaseByVersionFailure(error?.toString())
            );
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function activateLimitedReleaseByVersion(queryParams) {
  function activateLimitedReleaseByVersionLoad() {
    return {
      type: activateLimitedReleaseByVersionConstants.ACTIVATE_LIMITED_RELEASE_BY_VERSION_LOADING,
    };
  }
  function activateLimitedReleaseByVersionSuccess(data) {
    return {
      type: activateLimitedReleaseByVersionConstants.ACTIVATE_LIMITED_RELEASE_BY_VERSION_SUCCESS,
      data,
    };
  }
  function activateLimitedReleaseByVersionFailure(error) {
    return {
      type: activateLimitedReleaseByVersionConstants.ACTIVATE_LIMITED_RELEASE_BY_VERSION_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(activateLimitedReleaseByVersionLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesVersionService
        .activateLimitedReleaseByVersion(queryParams)
        .then(
          (data) => {
            dispatch(activateLimitedReleaseByVersionSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(activateLimitedReleaseByVersionFailure(error?.toString()));
            reject(error);
          }
        );
    });
  };
}

function deactivateLimitedReleaseByVersion(queryParams) {
  function deactivateLimitedReleaseByVersionLoad() {
    return {
      type: deactivateLimitedReleaseByVersionConstants.DEACTIVATE_LIMITED_RELEASE_BY_VERSION_LOADING,
    };
  }
  function deactivateLimitedReleaseByVersionSuccess(data) {
    return {
      type: deactivateLimitedReleaseByVersionConstants.DEACTIVATE_LIMITED_RELEASE_BY_VERSION_SUCCESS,
      data,
    };
  }
  function deactivateLimitedReleaseByVersionFailure(error) {
    return {
      type: deactivateLimitedReleaseByVersionConstants.DEACTIVATE_LIMITED_RELEASE_BY_VERSION_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(deactivateLimitedReleaseByVersionLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesVersionService
        .deactivateLimitedReleaseByVersion(queryParams)
        .then(
          (data) => {
            dispatch(deactivateLimitedReleaseByVersionSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(
              deactivateLimitedReleaseByVersionFailure(error?.toString())
            );
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function deleteLimitedReleaseByVersion(queryParams) {
  function deleteLimitedReleaseByVersionLoad() {
    return {
      type: deleteLimitedReleaseByVersionConstants.DELETE_LIMITED_RELEASE_BY_VERSION_LOADING,
    };
  }
  function deleteLimitedReleaseByVersionSuccess(data) {
    return {
      type: deleteLimitedReleaseByVersionConstants.DELETE_LIMITED_RELEASE_BY_VERSION_SUCCESS,
      data,
    };
  }
  function deleteLimitedReleaseByVersionFailure(error) {
    return {
      type: deleteLimitedReleaseByVersionConstants.DELETE_LIMITED_RELEASE_BY_VERSION_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(deleteLimitedReleaseByVersionLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesVersionService
        .deleteLimitedReleaseByVersion(queryParams)
        .then(
          (data) => {
            dispatch(deleteLimitedReleaseByVersionSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(deleteLimitedReleaseByVersionFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

export const limitedReleasesVersionActions = {
  getLimitedReleaseByVersion,
  createLimitedReleaseByVersion,
  editLimitedReleaseByVersion,
  addTargetLimitedReleaseByVersion,
  removeTargetLimitedReleaseByVersion,
  activateLimitedReleaseByVersion,
  deactivateLimitedReleaseByVersion,
  deleteLimitedReleaseByVersion,
};
